module.exports = __webpack_public_path__ + "static/media/invoice-icon.8cbf2e89.svg";